import { css, Interpolation, Theme } from '@emotion/react'

export const container: Interpolation<Theme> = (theme) => css`
  position: relative;
  height: 100vh;
  margin: 0 20px;
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: ${theme.backgrounds.backgroundThree};
  font-family: ${theme.fonts.family.PlusJakartaSans};
`

export const topSpace = css`
  flex: 1;
  min-height: 40px;
`

export const wrapper = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-sizing: border-box;
  width: 100%;
  max-width: 482px;
  padding: 35px 22px 22px;
  margin-top: 6px;
  border: 1px solid ${theme.backgrounds.backgroundTwo};
  border-radius: 24px;
  background-color: ${theme.colors.white};
  box-shadow: ${theme.boxShadows.medium};
`

export const bottomSpace = css`
  flex: 1;
  min-height: 120px;
  display: flex;
  align-items: end;
`

export const copyright = css`
  width: 100%;
  height: 99px;
  max-height: calc(100% - 26px);
  margin-top: 26px;
  display: block;
  text-align: center;
  line-height: 18px;
  color: #9a9a9a;
`
